const isPlainObject = value =>
  value !== null && typeof value === "object" && !Array.isArray(value);

const getNestedPathValue = (source, path) =>
  path.split(".").reduce((acc, key) => acc?.[key], source);

const setNestedPathValue = (target, path, value) => {
  const keys = path.split(".");
  const lastKey = keys[keys.length - 1];
  const parent = keys.slice(0, -1).reduce((acc, key) => {
    if (!isPlainObject(acc[key])) {
      acc[key] = {};
    }
    return acc[key];
  }, target);
  parent[lastKey] = value;
  return target;
};

export { getNestedPathValue, isPlainObject, setNestedPathValue };
